import * as React from 'react'
import { TextArea } from '@progress/kendo-react-inputs';
import { SystemBase } from '../common/SystemBase';

/**
 * Creates an Input with Label  
 * */
export default class SystemInputArea extends SystemBase {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <this.WrapperDiv>
            {/*    <TextArea style={this.props.style} id={this.props.id} name={this.props.name}  className="form-control" disabled={this.props.disabled}*/}
            {/*        value={this.state.value as string | number | string[] | undefined}*/}
            {/*        rows={this.props.rows} cols={this.props.cols}*/}
                {/*        onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur} />*/}
                <textarea maxLength={this.props.maxLength} id={this.props.id} rows={this.props.rows} name={this.props.name} cols={this.props.cols} value={this.state.value || ''}
                    onChange={this.handleChange} onFocus={this.handleFocus} onBlur={this.handleBlur}
                    className="form-controlTextArea"  disabled={ this.props.disabled } ></textarea>
            </this.WrapperDiv>
        );
    }
}

